var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP200Micropipette(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 111,
    viewBox: "0 0 17 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.98407 3.17383V11.4347H6.492V3.17383H9.98407Z",
    fill: "#8BB975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.98407 3.17383V4.04339H6.492V3.17383H9.98407Z",
    fill: "#72A45B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5682 3.17391H3.94283C3.90791 3.17391 3.87299 3.17391 3.87299 3.12087V1.43478C3.87299 1.43478 3.87299 1 4.30949 1H12.1666C12.5202 1 12.59 1.33739 12.601 1.41739C12.6025 1.42892 12.6033 1.44054 12.6031 1.45217V3.12087C12.6031 3.17391 12.6031 3.17391 12.5682 3.17391Z",
    fill: "#B0E298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.30951 2.08653C4.30951 2.02888 4.3325 1.97358 4.37343 1.93281C4.41436 1.89204 4.46988 1.86914 4.52776 1.86914C4.58565 1.86914 4.64116 1.89204 4.68209 1.93281C4.72302 1.97358 4.74602 2.02888 4.74602 2.08653V3.17349H4.30951V2.08653ZM6.05554 2.08653C6.05554 2.02888 6.07854 1.97358 6.11947 1.93281C6.1604 1.89204 6.21591 1.86914 6.2738 1.86914C6.33168 1.86914 6.38719 1.89204 6.42812 1.93281C6.46905 1.97358 6.49205 2.02888 6.49205 2.08653V3.17349H6.05554V2.08653ZM7.80157 2.08653C7.80157 2.02888 7.82457 1.97358 7.8655 1.93281C7.90643 1.89204 7.96194 1.86914 8.01983 1.86914C8.07771 1.86914 8.13323 1.89204 8.17416 1.93281C8.21509 1.97358 8.23808 2.02888 8.23808 2.08653V3.17349H7.80157V2.08653ZM9.5476 2.08653C9.5476 2.02888 9.5706 1.97358 9.61153 1.93281C9.65246 1.89204 9.70797 1.86914 9.76586 1.86914C9.82374 1.86914 9.87926 1.89204 9.92019 1.93281C9.96112 1.97358 9.98411 2.02888 9.98411 2.08653V3.17349H9.5476V2.08653ZM11.2936 2.08653C11.2936 2.02888 11.3166 1.97358 11.3576 1.93281C11.3985 1.89204 11.454 1.86914 11.5119 1.86914C11.5698 1.86914 11.6253 1.89204 11.6662 1.93281C11.7072 1.97358 11.7301 2.02888 11.7301 2.08653V3.17349H11.2936V2.08653ZM5.18253 2.08653C5.18253 2.02888 5.20552 1.97358 5.24645 1.93281C5.28738 1.89204 5.34289 1.86914 5.40078 1.86914C5.45866 1.86914 5.51418 1.89204 5.55511 1.93281C5.59604 1.97358 5.61903 2.02888 5.61903 2.08653V3.17349H5.18253V2.08653ZM6.92856 2.08653C6.92856 2.02888 6.95155 1.97358 6.99248 1.93281C7.03341 1.89204 7.08893 1.86914 7.14681 1.86914C7.2047 1.86914 7.26021 1.89204 7.30114 1.93281C7.34207 1.97358 7.36507 2.02888 7.36507 2.08653V3.17349H6.92856V2.08653ZM8.67459 2.08653C8.67459 2.02888 8.69758 1.97358 8.73851 1.93281C8.77944 1.89204 8.83496 1.86914 8.89284 1.86914C8.95073 1.86914 9.00624 1.89204 9.04717 1.93281C9.0881 1.97358 9.1111 2.02888 9.1111 2.08653V3.17349H8.67459V2.08653ZM10.4206 2.08653C10.4206 2.02888 10.4436 1.97358 10.4845 1.93281C10.5255 1.89204 10.581 1.86914 10.6389 1.86914C10.6968 1.86914 10.7523 1.89204 10.7932 1.93281C10.8341 1.97358 10.8571 2.02888 10.8571 2.08653V3.17349H10.4206V2.08653ZM12.1667 2.08653C12.1667 2.02888 12.1896 1.97358 12.2306 1.93281C12.2715 1.89204 12.327 1.86914 12.3849 1.86914C12.4428 1.86914 12.4983 1.89204 12.5392 1.93281C12.5802 1.97358 12.6032 2.02888 12.6032 2.08653V3.17349H12.1667V2.08653Z",
    fill: "#6C9F54"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.36056 84.7702H7.13905C7.02213 84.7702 6.92859 84.6598 6.92859 84.5218L6.92859 81.292H9.54764V84.5218C9.54764 84.6598 9.4541 84.7702 9.36056 84.7702Z",
    fill: "#99B2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.74603 54.3359H8.2381V73.9012H6.49206C6.49206 73.9012 6.24263 61.3794 4.74603 54.3359Z",
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7302 54.3359H8.2381V73.9012H9.98413C9.98413 73.9012 10.2336 61.3794 11.7302 54.3359Z",
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.49207 56.5165C6.49207 55.5522 7.27379 54.7705 8.2381 54.7705V54.7705C9.2024 54.7705 9.98413 55.5522 9.98413 56.5165V81.2853C9.98413 82.2496 9.2024 83.0314 8.2381 83.0314V83.0314C7.27379 83.0314 6.49207 82.2496 6.49207 81.2853V56.5165Z",
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6032 47.3789H3.87305L3.87305 54.3354C3.87305 54.8157 5.82736 55.205 8.23813 55.205C10.6489 55.205 12.6032 54.8157 12.6032 54.3354L12.6032 47.3789Z",
    fill: "#CCD8E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4749 48.6633L13.4749 13.0313C13.4749 12.4193 13.1457 12.1212 12.607 11.8589L10.6916 10.9265L8.2674 9.79004L5.57387 11.0722L3.8979 11.8589C3.32927 12.1212 3.00006 12.6457 3.00006 13.2576L3.00006 48.6834C3.00006 49.1637 5.34524 49.553 8.23816 49.553C11.1311 49.553 13.4763 49.1637 13.4763 48.6834C13.4763 48.6767 13.4758 48.67 13.4749 48.6633Z",
    fill: "#F5F7F9"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 9,
    width: 11,
    height: 41
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4749 48.6633L13.4749 13.0313C13.4749 12.4193 13.1457 12.1212 12.607 11.8589L10.6916 10.9265L8.2674 9.79004L5.57387 11.0722L3.8979 11.8589C3.32927 12.1212 3.00006 12.6457 3.00006 13.2576L3.00006 48.6834C3.00006 49.1637 5.34524 49.553 8.23816 49.553C11.1311 49.553 13.4763 49.1637 13.4763 48.6834C13.4763 48.6767 13.4758 48.67 13.4749 48.6633Z",
    fill: "#F5F7F9"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.00006,
    y: 11.7266,
    width: 2.61905,
    height: 37.8261,
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.8572,
    y: 11.7266,
    width: 2.61905,
    height: 37.8261,
    fill: "#E5ECF0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.26722 9.96513C9.39118 9.96513 10.3023 9.61288 10.3023 9.17836C10.3023 8.74385 9.39118 8.3916 8.26722 8.3916C7.14327 8.3916 6.23212 8.74385 6.23212 9.17836C6.23212 9.61288 7.14327 9.96513 8.26722 9.96513Z",
    fill: "#F5F7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0976 10.431C11.4991 9.49855 10.5713 8.79921 9.52381 8.50781C9.31431 8.65351 8.83546 8.74093 8.2369 8.74093C7.66827 8.74093 7.21935 8.65351 6.97993 8.53695C5.93244 8.85748 4.97475 9.49855 4.37618 10.4601C4.16669 10.8098 4.0769 11.2469 4.0769 11.6549V15.6469C4.0769 15.9675 4.37618 16.2006 4.70539 16.1714C5.69302 15.9966 6.86021 15.88 8.14712 15.88C9.52381 15.88 10.7209 15.9966 11.7684 16.1714C12.0976 16.2297 12.3969 15.9966 12.3969 15.6469L12.3969 11.5966C12.3969 11.1886 12.3071 10.7807 12.0976 10.431Z",
    fill: "#B0E298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.49786 11.1009C4.91686 10.5472 5.51542 10.1393 6.14391 9.81877C6.47312 9.67307 6.80232 9.55651 7.16146 9.4691C7.5206 9.38168 7.87973 9.35254 8.23887 9.35254C8.95714 9.35254 9.70534 9.49824 10.3338 9.81877C10.9923 10.1102 11.5609 10.5472 11.9799 11.1009C11.3813 10.7221 10.7828 10.4307 10.1543 10.2267C9.82506 10.1393 9.52578 10.0519 9.19657 9.9936C8.86736 9.93532 8.53815 9.90618 8.20894 9.90618C7.55052 9.90618 6.89211 10.0227 6.26362 10.1976C5.69499 10.4307 5.0665 10.7221 4.49786 11.1009Z",
    fill: "#8BB975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.98419 25.2051H6.49213L6.49213 37.3405H9.98419L9.98419 25.2051Z",
    fill: "#B0E298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25425 27.6543H7.26453L7.26453 34.7089H9.25425L9.25425 27.6543Z",
    fill: "#FBF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25425 27.6543H7.26453V27.8005H9.25425V27.6543Z",
    fill: "#A49448"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25425 34.5996H7.26453V34.7458H9.25425V34.5996Z",
    fill: "#A49448"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25425 32.2959H7.26453V32.4421H9.25425V32.2959Z",
    fill: "#A49448"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25425 29.957H7.26453V30.1032H9.25425V29.957Z",
    fill: "#A49448"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.28975 28.3525C8.42171 28.3525 8.52649 28.3889 8.60408 28.4617C8.68233 28.5338 8.72146 28.6301 8.72146 28.7508C8.72146 28.8427 8.69228 28.9422 8.63392 29.0494C8.57623 29.1566 8.47443 29.2986 8.32854 29.4754H8.80501V29.7071H7.90479V29.6793C8.00956 29.5549 8.09942 29.4432 8.17436 29.3443C8.24996 29.2447 8.30831 29.1624 8.34943 29.0973C8.39054 29.0316 8.41972 28.9757 8.43696 28.9298C8.45421 28.8838 8.46283 28.8363 8.46283 28.7871C8.46283 28.7259 8.44227 28.6745 8.40115 28.633C8.3607 28.5909 8.3113 28.5698 8.25294 28.5698C8.14816 28.5698 8.03941 28.6273 7.92667 28.7421V28.4799C8.04537 28.395 8.1664 28.3525 8.28975 28.3525Z",
    fill: "#101620"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.36141 30.6426C8.502 30.6426 8.61341 30.7035 8.69564 30.8254C8.77854 30.9473 8.81998 31.1139 8.81998 31.3251C8.81998 31.5383 8.7792 31.7064 8.69763 31.8296C8.61606 31.9528 8.50465 32.0143 8.3634 32.0143C8.22016 32.0143 8.10676 31.9534 8.02321 31.8315C7.94031 31.709 7.89886 31.5414 7.89886 31.3289C7.89886 31.1171 7.94031 30.9499 8.02321 30.8273C8.1061 30.7042 8.21884 30.6426 8.36141 30.6426ZM8.15749 31.3366C8.15749 31.6423 8.22547 31.7951 8.36141 31.7951C8.49404 31.7951 8.56036 31.6343 8.56036 31.3127C8.56036 31.0121 8.49338 30.8618 8.35942 30.8618C8.2248 30.8618 8.15749 31.0201 8.15749 31.3366Z",
    fill: "#101620"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.36392 32.9209C8.5045 32.9209 8.61591 32.9818 8.69814 33.1037C8.78104 33.2256 8.82249 33.3922 8.82249 33.6034C8.82249 33.8166 8.7817 33.9847 8.70013 34.1079C8.61857 34.2311 8.50716 34.2927 8.36591 34.2927C8.22266 34.2927 8.10927 34.2317 8.02571 34.1098C7.94281 33.9873 7.90137 33.8198 7.90137 33.6073C7.90137 33.3954 7.94281 33.2282 8.02571 33.1057C8.1086 32.9825 8.22134 32.9209 8.36392 32.9209ZM8.16 33.6149C8.16 33.9206 8.22797 34.0735 8.36392 34.0735C8.49655 34.0735 8.56286 33.9126 8.56286 33.591C8.56286 33.2904 8.49588 33.1401 8.36193 33.1401C8.22731 33.1401 8.16 33.2984 8.16 33.6149Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3679 11.7423V15.647C12.3679 15.9675 12.0985 16.2006 11.7394 16.1423C11.4102 16.0841 11.0511 16.0549 10.662 15.9966V11.043C11.1408 11.2178 11.4102 11.3635 11.8292 11.5383C12.1584 11.6258 12.1584 11.6258 12.3679 11.7423Z",
    fill: "#8BB975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.10748 11.7433L4.10748 15.6479C4.10748 15.9685 4.37684 16.2016 4.73597 16.1433C5.06518 16.085 5.42432 16.0559 5.81338 15.9976L5.81338 11.0439C5.33453 11.2188 5.06518 11.3645 4.64619 11.5393C4.31698 11.6267 4.31698 11.6267 4.10748 11.7433Z",
    fill: "#8BB975"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 16.4762,
    height: 116,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.4762,
    height: 110,
    fill: "white",
    transform: "translate(3 1)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.73016,
    height: 10.4348,
    fill: "white",
    transform: "translate(3.87299 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP200Micropipette);
export default __webpack_public_path__ + "static/media/P200_Micropipette.5b23e8c23b6b303e43aa35e1f90de508.svg";
export { ForwardRef as ReactComponent };